import { useEffect } from "react";

let lockCount = 0;
let savedScrollY = 0;

const applyLock = (): void => {
  if (lockCount === 0) {
    savedScrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";
  }
  lockCount += 1;
};

const releaseLock = (): void => {
  lockCount -= 1;
  if (lockCount > 0) {
    return;
  }

  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";
  document.body.style.overflow = "";
  window.scrollTo(0, savedScrollY);
};

/**
 * Prevents the document from scrolling while a mobile pinned edit card is open.
 * Uses a ref count so nested/overlapping locks (e.g. unmount during transition)
 * do not restore scroll prematurely. The iOS-safe `position: fixed` + saved
 * `scrollY` pattern — inner card scroll still works via its own overflow.
 */
export const useBodyScrollLock = (locked: boolean): void => {
  useEffect(() => {
    if (!locked) {
      return;
    }

    applyLock();

    return (): void => {
      releaseLock();
    };
  }, [locked]);
};

/** Test helper — resets module state between specs. */
export const resetBodyScrollLockForTests = (): void => {
  if (lockCount > 0) {
    lockCount = 1;
    releaseLock();
  }
  lockCount = 0;
  savedScrollY = 0;
};
